import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ProductClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/productClick.trackingInfo";

import { toProductImpression } from "@/services/tracking/mappers/productTileProduct.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: ProductClickTrackingInfo) => {
    const event: TypedAnalyticsEvent<ProductClickTrackingInfo> = {
        event: EventType.ProductClick,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackProductTile = (
    product: Product<ProductFieldSet.ProductTile>,
    list?: string,
    placement?: number
) => {
    const trackingInfo = {
        ...toProductImpression(product),
        list: list,
        placement: placement
    };

    track(trackingInfo);
};
